import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=9d4482ba&scoped=true"
import script from "./MemberInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MemberInfo.vue?vue&type=style&index=0&id=9d4482ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4482ba",
  null
  
)

export default component.exports